import React, { Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { useSetRecoilState } from "recoil";
import { matchingRangeState } from "../pages/Party/MatchingInfo/MatchingInfoFilter";

interface RangeModalProps {
  closeEvent: () => void;
  setIsChanged: Dispatch<SetStateAction<boolean>>;
  value: any[];
  setValue: Dispatch<SetStateAction<any>>;
  isChanged: boolean;
}

export default function RangeModal({
  closeEvent,
  setIsChanged,
  value,
  setValue,
  isChanged,
}: RangeModalProps) {
  const setSliderValue = useSetRecoilState(matchingRangeState);

  return (
    <>
      <RangeModalContainer>
        <StyledRange
          marks={{
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
          }}
          range
          min={1}
          max={12}
          defaultValue={[value[0], value[1]]}
          allowCross={false}
          onChange={(value: any) => {
            setValue(value);
            setIsChanged(true);
          }}
          dots={false}
        />
      </RangeModalContainer>

      <TransparentOverlay
        onClick={() => {
          if (isChanged) {
            setSliderValue(value);
          }
          closeEvent();
        }}
      />
    </>
  );
}

const RangeModalContainer = styled.div`
  position: absolute;
  top: 50px;
  right: 0px;
  width: 288px;
  height: 95px;
  border-radius: 10px;
  box-shadow: 0 5px 16px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  z-index: 3;
  display: flex;
  align-items: center;
  padding: 0 20px;
`;

export const TransparentOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

const StyledRange = styled(Slider)`
  .rc-slider {
    margin-top: 20px;
  }
  .rc-slider-mark {
    position: relative;
    top: -25px;
  }

  .rc-slider-mark-text {
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    color: ${({ theme }) => theme.color.gray600};
  }

  .rc-slider-track {
    background-color: ${({ theme }) => theme.buttonColor.blueNormal};
  }

  .rc-slider-step {
    height: 6px;
  }

  .rc-slider-dot {
    display: none;
  }

  .rc-slider-handle {
    width: 16px;
    height: 16px;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
    border: solid 0.5px #aaafb9;
    background-color: #ffffff;
    opacity: 1;
    margin-top: -6px;

    &:active {
      border-color: #aaafb9;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
    }
  }

  .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
    border-color: #aaafb9;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
  }
`;
